import React from "react";

export default function CustomTimePicker({
  value,
  onChange,
  disabled = false,
  label = "Horário da aplicação",
}) {
  return (
    <div>
      {label && (
        <label className="block text-xs font-bold uppercase tracking-wider text-[#6D6680] mb-1">
          {label}
        </label>
      )}

      <input
        type="time"
        disabled={disabled}
        value={value || "08:00"}
        onChange={(e) => onChange(e.target.value)}
        className="input-base h-11 w-full text-xs font-bold text-[#24152F] cursor-pointer"
        required
      />
    </div>
  );
}
